import { useEffect } from "react";
import "./App.css";

function App() {
  useEffect(() => {
    // Redirect to static HTML page
    window.location.href = '/index_static.html';
  }, []);

  return (
    <div className="App">
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        fontSize: '1.5rem',
        color: '#1e3a8a'
      }}>
        Redirecting to Hospitals IoT Landing Page...
      </div>
    </div>
  );
}

export default App;
